import React, { useState, useEffect, useContext } from "react";
import { Card, Spin, Carousel, Typography } from "antd";
import { PublicContext } from "../PublicContext";
import "../../styles/custom.css";
import dayjs from 'dayjs';

const { Meta } = Card;

export default function PromoCarousel() {
    const [loading, setLoading] = useState(true);
    const { uniquePromotions, products, selectedStore } = useContext(PublicContext);
    const { Title } = Typography;

    useEffect(() => {
        if (uniquePromotions != null) {
            setLoading(false);
        }
    }, [uniquePromotions]);

    function renderProductsTable(products) {
        const currentDate = dayjs();
        let storePromotions;
        if (localStorage.getItem("StorePromotions")) {
            storePromotions = JSON.parse(localStorage.getItem("StorePromotions")).filter(sp => sp.storeCode === selectedStore.current.storeCode && sp.isActive);
        }
        else {
            window.location.href = 'https://www.mandarinrestaurant.com/order-online/';
        }        

        let sortedUniquePromotions = uniquePromotions
            .filter(
                promotion =>
                    promotion.displayOrder >= 0 &&
                    currentDate.isAfter(promotion.activationDate) &&
                    currentDate.isBefore(promotion.expiryDate) &&
                    storePromotions.some(sp => sp.promotionId === promotion.id)
            )
            .sort((a, b) => a.displayOrder - b.displayOrder);
        return (
            <Carousel id="PromoCarousel" autoplay dots={true}>
                {sortedUniquePromotions.map((promotion) => {
                    if (promotion.promotionPicture.slice(-3) === "jpg" || promotion.promotionPicture.slice(-3) === "png") {
                        return (
                            <div
                                key={promotion.id}
                                className="carousel-item"
                            >
                                {promotion.promotionPicture.substring(0, 10) === "background" ?
                                    <div style={{ position: "relative", aspectRatio: "3.3693/1", width: "100%", height: "auto", overflow: "hidden" }}>
                                        <img
                                            alt={promotion.promotionName}
                                            src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/promotion/` + promotion.promotionPicture}
                                            style={{ width: "100%", aspectRatio: "3.3693/1", height: "auto", objectFit: "cover" }}
                                        />
                                        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center" }} >
                                            <p className="TextPromoCarouselTitle text-uppercase">{promotion.promotionName}</p>
                                            <p className="TextPromoCarouselDescription">{promotion.promotionDescription}</p>
                                        </div>
                                    </div>
                                    :
                                    <img
                                        alt={promotion.promotionName}
                                        src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/promotion/` + promotion.promotionPicture}
                                        style={{ aspectRatio: "3.3693/1", width: "100%", height: "auto", objectFit: "cover" }}
                                        onError={(e) => {
                                            e.target.src = "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png";
                                            e.target.onerror = null;
                                        }}
                                    />
                                }
                            </div>
                        );
                    }
                    return null;
                })}
            </Carousel>
        );
    }

    function renderLoading() {
        return <Spin />;
    }

    return (
        <div>
            {loading ? renderLoading() : renderProductsTable(products)}
        </div>
    );
}
